import { Component, Input } from '@angular/core';


@Component({
  selector: 'rms-hover-icon',
  templateUrl: './hover-icon.component.html',
  styleUrls: ['./hover-icon.component.scss'],
  standalone: false
})

export class HoverIconComponent {
  @Input() staticIconSVG: string;
  @Input() hoverIconSVG: string;
  @Input() iconHeight: string;
  @Input() iconId: string;
}
